import { Group, Stack, TextInput } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import {
  IconCertificate,
  IconHeartHandshake,
  IconSearch,
} from "@tabler/icons-react"
import { PaginationState } from "@tanstack/react-table"
import { DataFetchWrapper, Select } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import {
  supplierRiskFiltersSchema,
  supplierRiskFiltersValidationType,
} from "@tfg/types/schemas/organization/schemas"

import { i18n } from "~/i18n.ts"
import { SuppliersRisk } from "~/pages/Brand/Suppliers/List/SupplierRisk/SupplierRisk.tsx"
import { useListSuppliersRiskQuery } from "~/pages/Brand/Suppliers/List/supplierHooks.ts"

export const PAGE_SIZE = 15

const RISK_OPTIONS = [
  { label: i18n.t("suppliers:filter.risk.high"), value: "HIGH" },
  { label: i18n.t("suppliers:filter.risk.medium"), value: "MEDIUM" },
  { label: i18n.t("suppliers:filter.risk.low"), value: "LOW" },
]

export function SupplierRiskWrapper() {
  const { t } = useTranslation("suppliers")
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  })
  const [searchSupplier, setSearchSupplier] = useState<string>("")
  const [debouncedSupplier] = useDebouncedValue(searchSupplier, 600)
  const [filterValues, setFilterValues] =
    useState<supplierRiskFiltersValidationType>({
      riskCertification: undefined,
      riskCollaboration: undefined,
    })
  const suppliersRiskQuery = useListSuppliersRiskQuery({
    fetchDataOptions: pagination,
    searchSupplier: debouncedSupplier,
    filters: filterValues,
  })
  return (
    <Stack>
      <Group justify="apart">
        <Group>
          <TextInput
            label={t("list.searchLabel")}
            value={searchSupplier}
            autoFocus
            onChange={(e) => setSearchSupplier(e.target.value)}
            w={200}
            size="xs"
            leftSection={<IconSearch size={16} />}
            placeholder={t("list.searchPlaceholder")}
          />
          <Select
            w={150}
            size="xs"
            leftSection={<IconHeartHandshake size={16} />}
            label={t("list.collaborationRiskLabel")}
            data={RISK_OPTIONS}
            value={filterValues.riskCollaboration ?? null}
            placeholder={t("list.riskPlaceholder")}
            clearable
            onChange={(value) => {
              setFilterValues(
                supplierRiskFiltersSchema.parse({
                  ...filterValues,
                  riskCollaboration: value ?? undefined,
                })
              )
            }}
          />
          <Select
            w={150}
            size="xs"
            leftSection={<IconCertificate size={16} />}
            label={t("risk.table.certificationRisk")}
            data={RISK_OPTIONS}
            value={filterValues.riskCertification ?? null}
            placeholder={t("list.riskPlaceholder")}
            clearable
            onChange={(value) => {
              setFilterValues(
                supplierRiskFiltersSchema.parse({
                  ...filterValues,
                  riskCertification: value ?? undefined,
                })
              )
            }}
          />
        </Group>
      </Group>
      <DataFetchWrapper query={suppliersRiskQuery}>
        {({ data }) => (
          <SuppliersRisk
            suppliersData={data}
            pagination={pagination}
            setPagination={setPagination}
          />
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
